
<style scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
</style>
<template>
<div>
    <Modal
        :value="showModel"
        :title="title"
        :footer-hide="true"
        @on-cancel="cancel"
        :mask-closable="false"
        @on-visible-change="openOrClose">

        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
        <FormItem label="部门名称：" prop="cate_name">
            <Input type="text" v-model="formData.section_name"></Input>
        </FormItem>
        <FormItem label="部门负责人：" prop="leader_id" >
            <SelectList ref="topEmp" :url="searchEmpUrl" labelName='name' valName='id' keyword="keyword" @setSelected="setSelectVal($event,'leader_id')"></SelectList>
        </FormItem>
        <FormItem label="排序" prop="sort">
            <Input type="text" v-model="formData.sort"></Input>
        </FormItem>

        <FormItem>
            <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
        </FormItem>
    </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param topid Number 分类上级ID
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import SelectList from '../common/selectList';
    export default {
        props:{
            topid:Number,
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "Model1",
        components: {
            SelectList
        },
        data () {
            return {
                searchEmpUrl: this.config.urlArray.searchEmp,
                disabled:false,//禁用确定按钮
                title:'',//弹框标题
                formData: {//表单数据
                    section_name:'',
                    top_id:0,
                    sort: "100",
                    leader_id: 0,
                },
                ruleCustom: {//验证
                    section_name: [
                        { required: true, message: '部门名必须填写', trigger: 'blur' },
                        { min: 1, max: 100, message: '部门名长度1 - 250', trigger: 'blur' }
                    ],
                    leader_id: [
                        { required: true, message: '部门负责人必须选择', trigger: 'change' }
                    ],
                    sort: [
                        { required: true, message: '排序必须填写', trigger: 'blur' }
                    ],
                }
            }
        },
        methods: {
            openOrClose(value){
                if(value === true){
                    /**id:0,
                    cate_name:'',
                    sort_num: "100",
                    merchant_id: 0,
                    status: "1",
                    thumb:'' */
                    if(this.type == 2){//编辑表单时，给表单赋值
                        this.formData.id = this.editFormData.id
                        this.formData.section_name = this.editFormData.section_name
                        this.formData.top_id = this.editFormData.top_id.toString()
                        this.formData.sort = this.editFormData.sort.toString()
                        this.formData.leader_id = this.editFormData.leader_id.toString();
                        setTimeout(() => {
                            this.$refs.topEmp.setDefVal(Number(this.formData.leader_id));
                        }, 500);
                    }else{
                        this.formData.top_id = this.topid.toString();
                    }

                    this.title = this.type == 1?'添加部门':'编辑部门'
                }else{//关闭弹框后要做的处理
                    this.$refs.topEmp.clearVal();
                    this.$emit('update:topid',0)//更新上级IP为原始状态
                    this.resetForm();//重置表单
                }
            },
            subData (name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                        this.axios.post(this.config.urlArray.sectionsStore,this.formData).then((result) => {
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.$emit('update:topid',0)//更新上级IP为原始状态
                                this.fn()
                                },()=>{this.disabled = false;})

                        }).catch((err) => {
                            common.msg('error','提交失败',()=>{this.disabled = false;})
                        });
                    }
                })
            },

            setSelectVal(data,key){
                this.formData[key] = data.toString()
            },

            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm () {//重置表单
                this.$refs.topEmp.clearVal()
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
            },
        }
    }
</script>
